export default __webpack_public_path__ + "static/media/2502.52420383.png";